// Dedup guard for navigateWithQueryParams. It suppresses a repeat navigation
// when the filter query string is unchanged — this prevents redundant search
// calls during filter-click churn (clicking filters that don't change the
// resulting query).
//
// The invariant is "lastQueryString reflects what is currently on screen". That
// invariant breaks the moment the results are cleared for a new search
// (resetAllToStart calls setSongs([])), so the guard MUST be reset there.
// Otherwise an explicit new search that resolves to the SAME filters as the
// previous one is silently dropped — the cleared songs are never refetched and
// the user is left with an empty results screen.
let lastQueryString: string | undefined;

/**
 * Returns true if navigation should proceed for this query string, recording it
 * as the latest. Returns false (and changes nothing) when it equals the last
 * one — the caller should skip navigating.
 */
export function shouldNavigate(queryString: string): boolean {
  if (lastQueryString === queryString) {
    return false;
  }
  lastQueryString = queryString;
  return true;
}

/** Clear the dedup guard so the next navigation always proceeds. */
export function resetNavigateDedup(): void {
  lastQueryString = undefined;
}
